// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NodeInfo_wrapper___HgE3","header":"NodeInfo_header__1_rfs","detail":"NodeInfo_detail__2emUk"};